<template>
  <v-ons-list
    class="person-detail"
    modifier="noborder"
  >
    <person-outline :thing="destination" />

  </v-ons-list>
</template>

<script>
import personOutline from '@/components/map/partials/destination_outline/person.vue';

export default {
  components: {
    personOutline,
  },
  computed: {
    destination: ({ $store }) => $store.state.searchResult.destination,
  },
};
</script>



// WEBPACK FOOTER //
// person.vue?68e058d2